/**
 * MSAL configuration for Azure AD authentication.
 * Values are loaded from environment variables (set in .env).
 */

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AAD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AAD_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

/**
 * Scopes requested when acquiring tokens for your own API.
 * Replace with your actual API scope after creating the App Registration.
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

/**
 * Scopes for acquiring a token to call our backend API.
 * We use openid/profile/email so MSAL returns an ID token we can validate on the
 * server side. MS Graph access tokens (User.Read) cannot be validated by 3rd parties.
 * The ID token has aud=clientId and is signed by our tenant's keys.
 */
export const apiRequest = {
  scopes: ['openid', 'profile', 'email'],
};
